import { render, staticRenderFns } from "./ActiveGoodsList.vue?vue&type=template&id=62cb5c03&scoped=true&"
import script from "./ActiveGoodsList.vue?vue&type=script&lang=js&"
export * from "./ActiveGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./ActiveGoodsList.vue?vue&type=style&index=0&id=62cb5c03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cb5c03",
  null
  
)

export default component.exports